import { PipelinesTable } from '../../../../components/tables/PipelinesTable';

export const PipelinesPage = () => {
    return (
        <div className="w-full">
            <PipelinesTable fetchDataOnMount={false} isFromSelectPopup={false} />
        </div>
    );
};
